<template>
  <div class="evento-container">

   

    <!-- CARD -->
    <div class="evento-card" ref="card2">

      <img
        src="@/assets/8.png"
        alt="Ceremonia Civil"
        class="evento-icono"
      />

      <p class="evento-titulo">Celebración</p>

      <p class="evento-fecha">
        Sábado 05 de Diciembre
      </p>

      <p class="evento-lugar">
        Jardín Aztlan
      </p>

      <p class="evento-direccion">
        Carr. Federal A Cuernavaca 6382,
        San Andrés Totoltepec <br>
        Tlalpan, Ciudad de México.
      </p>

      <p class="evento-hora">
        4:30 P.M.
      </p>

      <a
        href="https://maps.app.goo.gl/DFUHYtTZ4Rj8hwEX8"
        class="btn-mapa"
        target="_blank"
      >
        VER MAPA
      </a>

    </div>
 <!-- FRASE ESPECIAL -->
    <div class="mensaje-mismo-lugar" ref="mensajeRef">
      La ceremonia y celebración <br>
      se realizarán en el mismo lugar
    </div>

    <!-- CROQUIS -->
<div class="croquis-container" ref="croquisRef">



  <button
    class="btn-croquis"
    @click="abrirModal"
  >
    VER CROQUIS
  </button>

</div>

<!-- MODAL -->
<div
  v-if="mostrarModal"
  class="modal-croquis"
  @click="cerrarModal"
>

  <img
    src="@/assets/croquis.webp"
    alt="Croquis"
    class="modal-img"
  />

</div>
  </div>
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {

  name: 'EventoSection',

  setup() {

    const card2 = ref(null)
    const mensajeRef = ref(null)
    const croquisRef = ref(null)

    const mostrarModal = ref(false)

    const abrirModal = async () => {

      mostrarModal.value = true

      await nextTick()

      gsap.fromTo(
        '.modal-img',
        {
          opacity: 0,
          scale: 0.8
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.7,
          ease: 'power3.out'
        }
      )
    }

    const cerrarModal = () => {

      gsap.to('.modal-img', {
        opacity: 0,
        scale: 0.8,
        duration: 0.25,
        ease: 'power2.in',
        onComplete: () => {
          mostrarModal.value = false
        }
      })
    }

    onMounted(() => {

      const observer = new IntersectionObserver(
        (entries) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              // MENSAJE
              if (entry.target === mensajeRef.value) {

                gsap.fromTo(
                  mensajeRef.value,
                  {
                    opacity: 0,
                    y: 30,
                    scale: 0.95
                  },
                  {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 1.2,
                    ease: 'power3.out'
                  }
                )
              }

              // CROQUIS
              if (entry.target === croquisRef.value) {

                const tlCroquis = gsap.timeline()

                tlCroquis.fromTo(
                  '.croquis-preview',
                  {
                    opacity: 0,
                    y: 30,
                    scale: 0.9
                  },
                  {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 1,
                    ease: 'power3.out'
                  }
                )

                tlCroquis.fromTo(
                  '.btn-croquis',
                  {
                    opacity: 0,
                    y: 20
                  },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: 'power3.out'
                  },
                  '-=0.5'
                )
              }

              // CARD
              if (entry.target === card2.value) {

                const tl = gsap.timeline()

                tl.fromTo(
                  card2.value,
                  {
                    opacity: 0,
                    y: 40
                  },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 1.2,
                    ease: 'power3.out'
                  }
                )

                tl.fromTo(
                  '.evento-icono',
                  {
                    opacity: 0,
                    scale: 0.7,
                    rotate: -10
                  },
                  {
                    opacity: 1,
                    scale: 1,
                    rotate: 0,
                    duration: 1,
                    ease: 'back.out(1.7)'
                  },
                  '-=0.8'
                )

                tl.fromTo(
                  '.evento-titulo, .evento-fecha, .evento-lugar, .evento-direccion, .evento-hora, .btn-mapa',
                  {
                    opacity: 0,
                    y: 15
                  },
                  {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.12,
                    ease: 'power2.out'
                  },
                  '-=0.8'
                )
              }

              observer.unobserve(entry.target)
            }
          })
        },
        {
          threshold: 0.3
        }
      )

      if (card2.value) {
        observer.observe(card2.value)
      }

      if (mensajeRef.value) {
        observer.observe(mensajeRef.value)
      }

      if (croquisRef.value) {
        observer.observe(croquisRef.value)
      }

    })

    return {
      card2,
      mensajeRef,
      croquisRef,

      mostrarModal,
      abrirModal,
      cerrarModal
    }
  }
}
</script>
<style scoped>

.evento-container {

  background-image: url('@/assets/7.png');
  background-size: cover;
  background-position: center;

  padding: 60px 20px;

  display: flex;
  flex-direction: column;
  align-items: center;

  color: #121111;

  position: relative;
  overflow: hidden;
}

/* MENSAJE */
.mensaje-mismo-lugar {

  font-family: 'padres', serif;
  font-size: 16px !important;
  line-height: 1.7;
  letter-spacing: 0.5px;

  text-align: center;

  color: #121111;

  margin-bottom: 35px;

  padding: 12px 24px;

  border-top: 1px solid rgba(0,0,0,0.15);
  border-bottom: 1px solid rgba(0,0,0,0.15);

  backdrop-filter: blur(2px);

  opacity: 0;
}

.evento-card {

  text-align: center;

  margin-bottom: 50px;

  max-width: 300px;

  opacity: 0;
}

.evento-icono {

  width: 58px;

  margin-bottom: 12px;
}

.evento-icono1 {

  width: 78px;

  margin-bottom: 12px;
}

.evento-titulo {

  font-family: 'Corinthia', cursive;

  font-size: 39px !important;

  color: #121111;

  margin: 0 0 6px;
}

.evento-fecha {

  font-family: 'padres', serif;

  font-size: 16px !important;

  color: #121111;

  margin-bottom: 6px;
}

.evento-lugar {

  font-family: 'padres', serif;

  font-size: 18px !important;

  font-weight: bold;

  color: #121111;

  margin-bottom: 6px;
}

.evento-direccion {

  font-family: 'padres', serif;

  font-size: 14px !important;

  color: #121111;

  margin-bottom: 6px;

  line-height: 1.6;
}

.evento-hora {

  font-family: 'fa', sans-serif;

  font-size: 16px !important;

  color: #121111;

  font-style: italic;

  margin-bottom: 12px;
}

.btn-mapa {

  background: transparent;

  border: 1px solid #292929;

  color: #1c1b1b;

  font-size: 17px;

  padding: 6px 18px;

  text-decoration: none;

  font-family: 'padres', serif;

  letter-spacing: 1px;

  transition: all 0.3s ease;

  display: inline-block;
}

.btn-mapa:hover {

  background: #fff;

  color: #111;

  transform: translateY(-2px);
}

.linea-division {

  width: 2px;

  height: 40px;

  background: #fff;

  margin: 20px 0;

  transform: scaleY(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {

  .mensaje-mismo-lugar {

    font-size: 12px;

    padding: 10px 18px;

    margin-bottom: 28px;
  }

  .evento-titulo {

    font-size: 48px !important;
  }

  .evento-direccion {

    font-size: 11px;
  }
}
/* CROQUIS */

.croquis-container {

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 14px;

  margin-top: 10px;

  opacity: 1;
}

.croquis-preview {

  width: 220px;
  max-width: 90vw;

  border-radius: 12px;

  cursor: pointer;

  box-shadow: 0 15px 35px rgba(0,0,0,.15);

  transition: .4s;
}

.croquis-preview:hover {

  transform: scale(1.03);
}

.btn-croquis {

  background: transparent;

  border: 1px solid #292929;

  color: #1c1b1b;

  font-size: 17px;

  padding: 8px 20px;

  font-family: 'padres', serif;

  letter-spacing: 1px;

  cursor: pointer;

  transition: .35s;
}

.btn-croquis:hover {

  transform: translateY(-3px);

  background: white;
}

/* MODAL */

.modal-croquis {

  position: fixed;

  inset: 0;

  background: rgba(0,0,0,.85);

  z-index: 99999;

  display: flex;

  justify-content: center;

  align-items: center;

  padding: 20px;
}

.modal-img {

  max-width: 95vw;

  max-height: 95vh;

  border-radius: 14px;

  box-shadow: 0 25px 60px rgba(0,0,0,.45);
}
</style>